export const headerFunc = (toggle, up, scrollToElement) => {
    const body = document.querySelector('body');
    const scrollUp = "scroll-up";
    const scrollDown = "scroll-down";
    let lastScroll = 0;

    window.addEventListener("scroll", () => {
        if(!header.classList.contains('stopProg')) {
            const currentScroll = window.pageYOffset;
            if (currentScroll <= 0) {
                body.classList.remove(scrollUp);
                return;
            } 
    
            if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
                body.classList.remove(scrollUp);
                body.classList.add(scrollDown);
            } else if (
                currentScroll < lastScroll &&
                body.classList.contains(scrollDown)
            ) {
                body.classList.remove(scrollDown);
                body.classList.add(scrollUp);
            }
            lastScroll = currentScroll;
        } else {
            lastScroll = 0;
        }
    });


      const header = document.querySelector('.header');
      const navMenu = document.querySelector('.header__nav');
      navMenu.addEventListener('mouseover', changeHeader);

      function changeHeader(e) {
        const width = window.innerWidth;

        if(width > 1024) {
            if(!header.classList.contains('stopProg')) {
                const isFirst = e.target.closest('.flex');
                const hasClass = e.target.closest('.menu-item-has-children');
                const isSubA = e.target.closest('li').closest('.sub-menu');
                
                if(isFirst) {
                    header.classList.add('hoveredHeader');
                }
                
                if(hasClass) {
                    header.classList.add('fixedDubble');
                    body.classList.add('bodyOverlay');
                }
        
                if(isSubA) {
                    e.target.closest('.sub-menu').classList.add('hovered');
                }
        
                e.target.onmouseout = function(event) {
                    header.classList.remove('fixedDubble');
                    header.classList.remove('hoveredHeader');
                    body.classList.remove('bodyOverlay');
                    if(e.target.closest('.sub-menu')) {
                        e.target.closest('.sub-menu').classList.remove('hovered');
                    }
                };
            }
        }
      }


    const hamburgerButton = document.querySelector('.hamburger');
    hamburgerButton.addEventListener('click', showNavBox);

    function showNavBox(e) {
        e.preventDefault();

        hamburgerButton.classList.toggle("active");
        body.classList.toggle('overhideMob');
        toggle(navMenu, {
            display: "flex"
        });
    };



    const parentItems = navMenu.querySelectorAll('.menu-item-has-children');

    parentItems.forEach(el => {
        el.addEventListener('click', openSubNav);
    })
    

    function openSubNav(e) {
        const width = window.innerWidth;

        if(width <= 1024) {
            const nav = e.currentTarget.querySelector('.sub-menu');

            if(e.target.closest('.sub-menu') || e.target.tagName === 'A') {
                e.stopPropagation();
            } else {
                e.preventDefault();
                e.currentTarget.classList.toggle("opened");
                toggle(nav);
            }
        }
    }


    const ankors = document.querySelectorAll('.ankor > a, a.ankor');

    if(ankors) {
        ankors.forEach(el => {
            el.addEventListener('click', e => {
                e.preventDefault();

                const width = window.innerWidth;
                const targ = e.target.getAttribute('href');
                const targetH = document.querySelector(targ);
                let offset = 0;

                if(targ && targetH) {
                    header.classList.add('stopProg');
                    body.classList.remove(scrollUp);
                    body.classList.add(scrollDown);
        
                    if(!targetH.classList.contains('noOffset')) {
                        if(width > 1024) {
                            header.classList.remove('fixedDubble');
                            header.classList.remove('hoveredHeader');
                            body.classList.remove('bodyOverlay');
        
                            const subNavs = header.querySelectorAll('.sub-menu');
                            subNavs.forEach(el => {
                                el.classList.remove('hovered');
                            });
        
                            offset = -80;
                        } else {
                            offset = -64;
                        }
                    }
    
                    if(width <= 1024) {
                        hamburgerButton.classList.remove("active");
                        body.classList.remove('overhideMob');
                        up(navMenu);
                    }
        
                    const options = {
                        offset: offset,
                        duration: 700
                    }
            
                    scrollToElement(targetH, options);
    
                    setTimeout(() => {
                        header.classList.remove('stopProg');
                    }, "1000");
                } else {
                    const protocol = window.location.protocol;
                    const host = document.location.host;
                    const url = protocol+'//'+host+targ;

                    console.log(url)

                    window.location.href = url;
                }
            })
        });
    }
};